/**
 * Fills an HTML template the same way the backend will at issuance, so the
 * Preview stage shows exactly what recipients get.
 */
import { createVariableRegex, escapeHtml } from "../model/variables";

const SAFE_IMAGE_URL =
  /^(https?:|blob:|data:image\/(png|jpe?g|gif|webp|svg\+xml);)/i;

const IMAGE_TOKEN_SRC = new RegExp(
  `src="${createVariableRegex().source}"`,
  "g",
);
const QR_SLOT =
  /(<div\b[^>]*\bdata-slot="qr"[^>]*>)(?:(?!<\/div>)[\s\S])*(<\/div>)/g;

/**
 * @param {string} html     output of toHtml()
 * @param {Object<string,string>} values
 * @param {{ qrDataUrl?: string, missing?: "token"|"empty" }} [options]
 */
export function renderHtml(html, values = {}, options = {}) {
  const { qrDataUrl, missing = "empty" } = options;

  let output = String(html).replace(IMAGE_TOKEN_SRC, (full, key) => {
    const value = String(values[key] ?? "").trim();
    return SAFE_IMAGE_URL.test(value)
      ? `src="${escapeHtml(value)}"`
      : 'src="" data-missing="true"';
  });

  output = output.replace(createVariableRegex(), (token, key) => {
    const value = values[key];
    if (value === undefined || value === null || value === "") {
      return missing === "token" ? token : "";
    }
    return escapeHtml(value);
  });

  if (qrDataUrl && SAFE_IMAGE_URL.test(qrDataUrl)) {
    output = output.replace(
      QR_SLOT,
      (full, open, close) =>
        `${open}<img src="${escapeHtml(qrDataUrl)}" alt="" style="width:100%;height:100%;display:block">${close}`,
    );
  }

  return output;
}
